<template>
    <div class="user-detail-wrap-out">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="doctorDetail-wrap" v-loading="loading">
            <div class="hospital-title">
                <div>
                    <i class="iconfont icon-tongyongbiaotiicon"></i
                    ><span>医生信息</span>
                </div>
                <div
                    class="title-edit"
                    v-show="!editShow"
                    @click="editShow = true"
                >
                    <i class="iconfont icon-edit1"></i><span>编辑</span>
                </div>
            </div>
            <!-- 查看基本信息 -->
            <div class="doctorDetail-wrap-see" v-show="!editShow">
                <div class="doctor-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="avtar-cover">
                                <img
                                    v-if="doctorMessage.accountHead"
                                    :src="strUrl + doctorMessage.accountHead"
                                    class="papers"
                                    @click="avartIn(imageUrl)"
                                />
                                <div v-else class="info-avart-none">
                                    <i class="iconfont icon-Avatar"></i>
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">姓名:</div>
                                <div class="info-message">
                                    {{ doctorMessage.accountName || "暂无" }}
                                </div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label">身份证号:</div>
                                <div class="info-message">
                                    {{ doctorMessage.idCard || "暂无" }}
                                </div>
                            </div>

                            <div class="base-info-wrap">
                                <div class="info-label">学历:</div>
                                <div class="info-message">
                                    {{
                                        doctorMessage.educationBackgroundName ||
                                            "暂无"
                                    }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label">性别:</div>
                                <div class="info-message">
                                    {{
                                        sex[doctorMessage.accountSex] || "暂无"
                                    }}
                                </div>
                            </div>
                            <!-- <div class="base-info-wrap">
                                <div class="info-label">工号:</div>
                                <div class="info-message">{{doctorMessage.accountNumber || '暂无'}}</div>
                            </div> -->
                            <div class="base-info-wrap">
                                <div class="info-label">登录手机号:</div>
                                <div class="info-message">
                                    {{ doctorMessage.phone || "暂无" }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="doctor-base-info">
                    <div class="info-title">执业信息</div>
                    <el-row>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label info-label-min">
                                    医院:
                                </div>
                                <div class="info-message">
                                    {{ doctorMessage.hospitalName || "暂无" }}
                                </div>
                            </div>
                            <div class="base-info-wrap">
                                <div class="info-label info-label-min">
                                    医生集团:
                                </div>
                                <div class="info-message">
                                    {{ doctorMessage.groups || "暂无" }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div class="base-info-wrap">
                                <div class="info-label info-label-te">
                                    科室:
                                </div>
                                <div class="info-message">
                                    {{ doctorMessage.departName || "暂无" }}
                                </div>
                            </div>
                            <div
                                class="base-info-wrap"
                                style="margin-bottom: 16px"
                            >
                                <div class="info-label info-label-te">
                                    职称:
                                </div>
                                <div class="info-message">
                                    {{ doctorMessage.titleName || "暂无" }}
                                </div>
                            </div>
                        </el-col>
                        <el-col :span="8">
                            <div
                                class="base-info-wrap"
                            >
                             <!-- v-if="doctorMessage.hospitalId === '34'" -->
                                <div class="info-label">工号:</div>
                                <div class="info-message">
                                    {{ doctorMessage.accountNumber || "暂无" }}
                                </div>
                            </div>
                            <div
                                class="base-info-wrap"
                                style="margin-bottom: 16px"
                            >
                                <div class="info-label">教职:</div>
                                <div class="info-message">
                                    {{ doctorMessage.educationName || "暂无" }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="8">
                            <div
                                class="base-info-wrap"
                                style="margin-bottom: 16px"
                            >
                                <div class="info-label">角色:</div>
                                <div class="info-message">
                                    {{ doctorMessage.roles || "暂无" }}
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    <div class="base-info-wrap" style="margin-bottom: 16px">
                        <div
                            class="info-label info-label-min"
                            style="line-height: 22px"
                        >
                            简介:
                        </div>
                        <div class="info-message-detail">
                            {{ doctorMessage.doctorResume || "暂无" }}
                        </div>
                    </div>
                    <div class="base-info-wrap" style="margin-bottom: 16px">
                        <div
                            class="info-label info-label-min"
                            style="line-height: 22px"
                        >
                            擅长:
                        </div>
                        <div class="info-message-detail">
                            {{ doctorMessage.doctorSpecial || "暂无" }}
                        </div>
                    </div>
                </div>
                <div class="doctor-cert-info">
                    <div class="info-title">认证信息</div>
                    <div class="info-cert-wrap">
                        <div class="info-cert-item">
                            <div class="info-label">身份证正面:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <img
                                        v-if="doctorMessage.idCardFront"
                                        :src="
                                            strUrl + doctorMessage.idCardFront
                                        "
                                        class="papers"
                                        @click="
                                            toPreview(doctorMessage.idCardFront)
                                        "
                                    />
                                    <div v-else class="info-message">
                                        暂无身份证正面
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">工作证或参会胸牌:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <img
                                        v-if="doctorMessage.otherCard"
                                        :src="strUrl + doctorMessage.otherCard"
                                        class="papers"
                                        @click="
                                            toPreview(doctorMessage.otherCard)
                                        "
                                    />
                                    <div v-else class="info-message">
                                        暂无工作证或参会胸牌
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">医师注册执业证:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <img
                                        v-if="
                                            doctorMessage.medicalRegisterFirst
                                        "
                                        :src="
                                            strUrl +
                                                doctorMessage.medicalRegisterFirst
                                        "
                                        class="papers"
                                        @click="
                                            toPreview(
                                                doctorMessage.medicalRegisterFirst
                                            )
                                        "
                                    />
                                    <div v-else class="info-message">暂无</div>
                                </div>
                                <div class="pic-back">
                                    <img
                                        v-if="
                                            doctorMessage.medicalRegisterSecond
                                        "
                                        :src="
                                            strUrl +
                                                doctorMessage.medicalRegisterSecond
                                        "
                                        class="papers"
                                        @click="
                                            toPreview(
                                                doctorMessage.medicalRegisterSecond
                                            )
                                        "
                                    />
                                    <div v-else class="info-message">暂无</div>
                                </div>
                            </div>
                        </div>
                        <div class="info-cert-item">
                            <div class="info-label">执业医师资格证:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <img
                                        v-if="doctorMessage.medicalLicenseFirst"
                                        :src="
                                            strUrl +
                                                doctorMessage.medicalLicenseFirst
                                        "
                                        class="papers"
                                        @click="
                                            toPreview(
                                                doctorMessage.medicalLicenseFirst
                                            )
                                        "
                                    />
                                    <div v-else class="info-message">暂无</div>
                                </div>
                                <div class="pic-back">
                                    <img
                                        v-if="
                                            doctorMessage.medicalLicenseSecond
                                        "
                                        :src="
                                            strUrl +
                                                doctorMessage.medicalLicenseSecond
                                        "
                                        class="papers"
                                        @click="
                                            toPreview(
                                                doctorMessage.medicalLicenseSecond
                                            )
                                        "
                                    />
                                    <div v-else class="info-message">暂无</div>
                                </div>
                            </div>
                        </div>

                        <div class="info-cert-item">
                            <div class="info-label">专业技术资格证:</div>
                            <div class="info-pic">
                                <div class="pic-cover">
                                    <img
                                        v-if="doctorMessage.techFirst"
                                        :src="strUrl + doctorMessage.techFirst"
                                        class="papers"
                                        @click="
                                            toPreview(doctorMessage.techFirst)
                                        "
                                    />
                                    <div v-else class="info-message">暂无</div>
                                </div>
                            </div>
                        </div>

                        <div class="info-cert-item" style="margin-bottom: 10px">
                            <div class="info-label">电子签名:</div>
                            <div class="info-message">
                                <img
                                    v-if="doctorMessage.signatureUrl"
                                    :src="strUrl + doctorMessage.signatureUrl"
                                    class="paper-sign"
                                    @click="
                                        toPreview(doctorMessage.signatureUrl)
                                    "
                                />
                                <div v-else>暂无</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 打标签 -->
                <div class="doctor-base-info set-label see-set-label">
                    <div class="info-title">标签信息</div>
                    <div class="label-wrap">
                        <div class="label-team" style="margin-bottom: 10px">
                            <div
                                class="label-team-left"
                                style="line-height: 24px"
                            >
                                院士团队:
                            </div>
                            <div class="label-team-right">
                                <div
                                    class="label-team-content"
                                    v-if="temaListShowSee.length > 0"
                                    style="margin-top: 0px"
                                >
                                    <div
                                        class="team-content-item"
                                        v-for="(item, index) in temaListShowSee"
                                        :key="index"
                                    >
                                        <i
                                            class="iconfont icon-user1 wow-user"
                                        ></i>
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    style="line-height: 24px; margin-top: 10px"
                                >
                                    暂无
                                </div>
                            </div>
                        </div>
                        <div class="label-team" style="margin-bottom: 10px">
                            <div
                                class="label-team-left"
                                style="line-height: 24px"
                            >
                                会诊科室:
                            </div>
                            <div class="label-team-right">
                                <div
                                    class="label-team-content"
                                    v-if="departListShowSee.length > 0"
                                    style="margin-top: 0px"
                                >
                                    <div
                                        class="team-content-item"
                                        v-for="(item,
                                        index) in departListShowSee"
                                        :key="index"
                                    >
                                        <span class="wow-folder"></span>
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                                <div
                                    v-else
                                    style="line-height: 24px; margin-top: 10px"
                                >
                                    暂无
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 打标签结束 -->
            </div>
            <!-- 编辑信息 -->
            <el-form
                v-show="editShow"
                :model="ruleForm"
                ref="ruleForm"
                class="rule-from"
            >
                <div class="doctor-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label-width="14px">
                                <div class="avart-wrap">
                                    <!-- 遮罩 -->
                                    <div class="cover-custom" v-show="imageUrl">
                                        <div class="cover-wrap">
                                            <i
                                                class="el-icon-zoom-in"
                                                @click="avartIn(imageUrl)"
                                            ></i>
                                            <i
                                                class="el-icon-delete"
                                                @click="avartDele"
                                            ></i>
                                        </div>
                                    </div>
                                    <el-upload
                                        class="avatar-uploader"
                                        action=""
                                        :auto-upload="false"
                                        :show-file-list="false"
                                        list-type="picture-card"
                                        :http-request="uploadFile"
                                        :on-change="changeUpload"
                                        accept=".jpg, .png"
                                    >
                                        <img
                                            v-if="imageUrl"
                                            :src="imageUrl"
                                            class="avatar-show"
                                        />
                                        <div else class="avatar-img">
                                            <i class="iconfont icon-camera"></i>
                                            <div class="uploader-title">
                                                上传头像
                                            </div>
                                        </div>
                                    </el-upload>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="姓名"
                                label-width="104px"
                                prop="accountName"
                                :rules="[
                                    { required: true, message: '请输入姓名' }
                                ]"
                            >
                                <el-input
                                    v-model="ruleForm.accountName"
                                    placeholder="请输入姓名"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="身份证号"
                                label-width="104px"
                                prop="idCard"
                                :rules="[
                                    {
                                        required: false,
                                        message: '请输入身份证号',
                                        trigger: 'blur'
                                    },
                                    {
                                        required: false,
                                        message: '请输入身份证号',
                                        trigger: 'change'
                                    },
                                    {
                                        required: false,
                                        validator: checkId,
                                        trigger: 'blur'
                                    },
                                    {
                                        required: false,
                                        validator: checkId,
                                        trigger: 'change'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model="ruleForm.idCard"
                                    placeholder="请输入身份证号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>

                            <el-form-item
                                label="学历"
                                label-width="104px"
                                prop="hospitalName"
                            >
                                <el-select
                                    v-model="ruleForm.educationBackgroundCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleEducationChange"
                                    @clear="handleEducationChange"
                                    placeholder="请选择学历"
                                >
                                    <el-option
                                        v-for="(item, index) in educationList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="性别"
                                label-width="104px"
                                prop="accountSex"
                            >
                                <el-radio-group v-model="ruleForm.accountSex">
                                    <el-radio label="1">男</el-radio>
                                    <el-radio label="0">女</el-radio>
                                    <el-radio label="2">未知</el-radio>
                                </el-radio-group>
                            </el-form-item>
                            <el-form-item
                                label="登录手机号"
                                label-width="104px"
                                prop="phone"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请输入登录手机号'
                                    },
                                    {
                                        pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                                        required: true,
                                        message: '请输入正确的登录手机号'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model="ruleForm.phone"
                                    placeholder="请输入登录手机号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    :disabled="noEdit"
                                    maxlength="20"
                                >
                                </el-input>
                                <el-button
                                    type="text"
                                    class="accout-link"
                                    v-if="accountShow"
                                    @click="handleAccountShow"
                                >
                                    关联账号
                                </el-button>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <div class="doctor-base-info">
                    <div class="info-title">执业信息</div>
                    <el-row>
                        <el-col :span="8" class="auto-select">
                            <el-form-item
                                label="医院"
                                label-width="88px"
                                prop="hospitalId"
                                :rules="[
                                    { required: true, message: '请输入医院' }
                                ]"
                            >
                                <el-select
                                    filterable
                                    clearable
                                    remote
                                    :disabled="haveDept"
                                    :remote-method="getHospital"
                                    :loading="isSearchDept"
                                    loading-text="正在搜索医院，请稍后..."
                                    v-model="ruleForm.hospitalId"
                                    placeholder="请输入关键字搜索"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleHosChange"
                                    @clear="handleHosChange"
                                >
                                    <el-option
                                        :label="item.hospitalName"
                                        :value="item.hospitalId"
                                        v-for="(item, index) in hospitalList"
                                        :key="index"
                                    ></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item
                                label="医生集团"
                                label-width="88px"
                                prop="hospital"
                            >
                                <el-select
                                    multiple
                                    filterable
                                    remote
                                    :disabled="haveDept"
                                    :remote-method="getGroup"
                                    :loading="isSearchDept"
                                    loading-text="正在搜索医生集团，请稍后..."
                                    v-model="ruleForm.groupIds"
                                    placeholder="请输入关键字搜索"
                                    :style="{ width: '210px' }"
                                    size="small"
                                >
                                    <el-option
                                        :label="item.groupName"
                                        :value="item.groupId"
                                        v-for="item in gropList"
                                        :key="item.groupId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="科室"
                                label-width="104px"
                                prop="departmentId"
                                :rules="[
                                    { required: true, message: '请输入科室' }
                                ]"
                            >
                                <!-- <el-select filterable
                                           clearable
                                           remote
                                           :disabled="haveDept"
                                           :remote-method="getDepart"
                                           :loading="isSearchDept"
                                           loading-text="正在搜索科室，请稍后..."
                                           v-model="ruleForm.departmentId"
                                           placeholder="请输入关键字搜索"
                                           :style="{width: '200px'}"
                                           popper-class="deptSelect"
                                           size="small">
                                    <el-option :label="item.groupName"
                                               :value="item.groupId"
                                               v-for="(item, index) in departList"
                                               :key="index"></el-option>
                                </el-select> -->
                                <el-cascader
                                    class="form-cas-select"
                                    size="small"
                                    :style="{ width: '210px' }"
                                    v-model="ruleForm.departmentId"
                                    placeholder="请选择科室"
                                    :options="departList"
                                    :props="defaultProps"
                                    @focus="isHaveHospital"
                                    :visible-arrow="false"
                                    clearable
                                    filterable
                                ></el-cascader>
                            </el-form-item>
                            <el-form-item
                                label="职称"
                                label-width="104px"
                                prop="titleCode"
                                :rules="[
                                    { required: true, message: '请选择职称' }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.titleCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleTitleChange"
                                    @clear="handleTitleChange"
                                    placeholder="请选择职称"
                                >
                                    <el-option
                                        v-for="(item, index) in doctorJobList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" class="auto-select">
                            <el-form-item
                                label="工号"
                                label-width="104px"
                                prop="accountNumber"
                            >
                              <!-- :rules="[
                                    { required: true, message: '请输入工号' }
                                ]"
                                v-if="ruleForm.hospitalId === '34'" -->
                                <el-input
                                    v-model="ruleForm.accountNumber"
                                    placeholder="请输入工号"
                                    :style="{ width: '210px' }"
                                    size="small"
                                >
                                </el-input>
                            </el-form-item>

                            <el-form-item
                                label="教职"
                                label-width="104px"
                                prop="educationCode"
                            >
                                <el-select
                                    v-model="ruleForm.educationCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="handleEduChange"
                                    @clear="handleEduChange"
                                    placeholder="请选择教职"
                                >
                                    <el-option
                                        v-for="(item, index) in facultyList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row>
                        <el-col :span="8">
                            <el-form-item
                                label="角色"
                                label-width="88px"
                                prop="roleIds"
                            >
                                <el-select
                                    v-model="ruleForm.roleIds"
                                    multiple
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    placeholder="请选择角色"
                                >
                                    <el-option
                                        v-for="(item, index) in roleList"
                                        :key="index"
                                        :label="item.roleName"
                                        :value="item.roleId"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item
                        class="form-details"
                        label="简介"
                        label-width="88px"
                        prop="doctorResume"
                    >
                        <el-input
                            v-model.trim="ruleForm.doctorResume"
                            type="textarea"
                            :style="{ width: '720px', height: '132px' }"
                            placeholder="请输入简介"
                            maxlength="700"
                            show-word-limit
                            class="introduction-detail"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        class="form-details"
                        label="擅长"
                        label-width="88px"
                        prop="doctorSpecial"
                    >
                        <el-input
                            v-model.trim="ruleForm.doctorSpecial"
                            type="textarea"
                            :style="{ width: '720px', height: '132px' }"
                            placeholder="请输入擅长"
                            maxlength="700"
                            show-word-limit
                            class="introduction-detail"
                        ></el-input>
                    </el-form-item>
                </div>
                <div class="doctor-base-info cert-info">
                    <div class="info-title">
                        认证信息<span class="heart-warning"
                            >(提示:建议图片小于10M,图片格式为png、jpg、jpeg)</span
                        >
                    </div>
                    <el-form-item
                        label="身份证正面"
                        label-width="140px"
                        class="item-last"
                        prop="idCardFront"
                        :rules="[
                            { required: false, message: '请上传身份证正面照' }
                        ]"
                        style="border-bottom: 1px dashed #cccccc; padding-bottom: 20px"
                    >
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleCardFrontSuccess"
                            :on-remove="handleCardFrontRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile1"
                            :file-list="idCardFrontFileList"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="sfz_renxiang" />
                        </el-upload>

                        <div class="heart-warning">请上传身份证正面照</div>
                    </el-form-item>

                    <div class="form-tips-text">
                        请上传医师注册执业证、执业医师资格证、专业技术资格证、工作证或参会胸牌（至少一项必填）
                    </div>

                    <el-form-item
                        label="工作证或参会胸牌"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleOtherCardSuccess"
                            :on-remove="handleOtherCardRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile2"
                            :file-list="otherCardFileList"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="sfz_renxiang" />
                        </el-upload>
                    </el-form-item>

                    <el-form-item
                        label="医师注册执业证"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleRegisterFirstSuccess"
                            :on-remove="handleRegisterFirstRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile3"
                            :file-list="registFirstFileList"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_1" />
                        </el-upload>

                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleRegisterSecondSuccess"
                            list-type="picture-card"
                            :on-remove="handleRegisterSecondRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile3"
                            :file-list="registSecondFileList"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_" />
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="执业医师资格证"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleLicenseFirstSuccess"
                            :on-remove="handleLicenseFirstRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile4"
                            :file-list="practiceFirstFileList"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_1" />
                        </el-upload>

                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleLicenseSecondSuccess"
                            list-type="picture-card"
                            :on-remove="handleLicenseSecondRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile4"
                            :file-list="practiceSecondFileList"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_" />
                        </el-upload>
                    </el-form-item>

                    <el-form-item
                        label="专业技术资格证"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleTechFirstSuccess"
                            :on-remove="handleTechFirstRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile5"
                            :file-list="techFirstFileList"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="license_1" />
                        </el-upload>
                    </el-form-item>
                    <el-form-item
                        label="电子签名"
                        label-width="140px"
                        class="item-last"
                    >
                        <el-upload
                            class="ele-sign"
                            :action="picUrl"
                            :headers="headers"
                            :on-success="handleSignSuccess"
                            :on-remove="handleSignRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile"
                            :file-list="signFileList"
                            list-type="picture-card"
                            accept=".jpg, .png, .jpeg"
                        >
                            <div class="sign-qian">
                                <svg-icon icon-class="add_img" />
                            </div>
                        </el-upload>
                    </el-form-item>
                </div>
                <!-- 打标签 -->
                <div class="doctor-base-info set-label">
                    <div class="info-title">标签信息</div>
                    <div class="label-wrap">
                        <div class="label-team">
                            <div class="label-team-left">院士团队</div>
                            <div class="label-team-right">
                                <div
                                    class="label-team-select"
                                    @click="showTemaList('tema')"
                                >
                                    <i class="el-icon-circle-plus-outline"></i>
                                    <span>选择团队</span>
                                </div>
                                <div
                                    class="label-team-content"
                                    v-if="temaListShow.length > 0"
                                >
                                    <div
                                        class="team-content-item"
                                        v-for="(item, index) in temaListShow"
                                        :key="index"
                                    >
                                        <i
                                            class="iconfont icon-user1 wow-user"
                                        ></i>
                                        <span>{{ item.name }}</span>
                                        <i
                                            class="el-icon-close wow-close"
                                            @click="
                                                hanldeDeleShow(
                                                    item.groupId,
                                                    index,
                                                    'tema'
                                                )
                                            "
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="label-team">
                            <div class="label-team-left">会诊科室</div>
                            <div class="label-team-right">
                                <div
                                    class="label-team-select"
                                    @click="showTemaList('depart')"
                                >
                                    <i class="el-icon-circle-plus-outline"></i>
                                    <span>选择科室</span>
                                </div>
                                <div
                                    class="label-team-content"
                                    v-if="departListShow.length > 0"
                                >
                                    <div
                                        class="team-content-item"
                                        v-for="(item, index) in departListShow"
                                        :key="index"
                                    >
                                        <span class="wow-folder"></span>
                                        <span>{{ item.name }}</span>
                                        <i
                                            class="el-icon-close wow-close"
                                            @click="
                                                hanldeDeleShow(
                                                    item.groupId,
                                                    index,
                                                    'depart'
                                                )
                                            "
                                        ></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 打标签结束 -->
            </el-form>
        </div>
        <div class="add-btn-bottom" v-show="editShow">
            <el-button
                type="warning"
                size="small"
                @click="handleEdit()"
                :disabled="flag"
                >保 存</el-button
            >
            <el-button type="info" size="small" plain @click="isCancle()"
                >取 消</el-button
            >
        </div>
        <el-dialog
            :visible.sync="dialogVisible"
            :destroy-on-close="true"
            :show-close="false"
            width="600px"
            @close="clearUrl"
            class="ww-pre-dialog"
        >
            <img width="100%" :src="dialogImageUrl" alt="" />
            <span slot="title">
                <el-image
                    class="icon-delete"
                    :src="deleteUrl"
                    @click="clearUrl"
                >
                </el-image>
            </span>
        </el-dialog>
        <!-- 裁剪图片弹框 -->
        <el-dialog
            :visible.sync="cropperVisible"
            :destroy-on-close="true"
            width="718px"
            title="头像编辑"
            class="ww-dialog"
        >
            <CropperPic
                ref="vueCropper"
                :imgFile="fileImg"
                @uploadFile="uploadFile"
            >
            </CropperPic>
        </el-dialog>
        <el-dialog
            :visible.sync="cropperPrewVisible"
            :show-close="false"
            top="30vh"
            width="400px"
            class="ww-pre-dialog"
        >
            <span slot="title">
                <el-image
                    class="icon-delete"
                    :src="deleteUrl"
                    @click="handleAvartClose"
                >
                </el-image>
            </span>
            <img width="100%" :src="imagePrewUrl" alt="" />
        </el-dialog>

        <el-dialog
            title="关联账号"
            :visible.sync="dialogAccountVisible"
            :close-on-click-modal="false"
            custom-class="account-dialog"
            width="400px"
            top="30vh"
            :before-close="handleClose"
        >
            <div class="account-wrap" v-loading="accountLoading">
                <el-form
                    ref="accountForm"
                    :model="accountForm"
                    label-width="80px"
                >
                    <el-form-item
                        label="手机号"
                        prop="phone"
                        :rules="[
                            {
                                required: true,
                                message: '请输入手机号',
                                trigger: 'blur'
                            },
                            {
                                pattern: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
                                required: true,
                                message: '请输入正确的手机号'
                            }
                        ]"
                    >
                        <el-input
                            class="phone-input"
                            placeholder="请输入手机号"
                            @input="clearError"
                            v-model="accountForm.phone"
                            :disabled="phoneDisabled"
                        >
                        </el-input>
                        <p class="error-mes" v-if="errorShow">
                            该手机号已注册，点击继续将合并账号
                        </p>
                        <p class="error-mes" v-if="errorShow2">
                            该手机号已认证，无法关联，请更改手机号
                        </p>
                    </el-form-item>
                </el-form>
                <div class="dialog-footer">
                    <el-button
                        class="confirm-btn"
                        v-if="!nextShow"
                        @click="handleAccountConfirm"
                        >确 定</el-button
                    >
                    <el-button
                        class="confirm-btn"
                        v-if="nextShow"
                        @click="handleNext"
                        >继 续</el-button
                    >
                    <el-button class="cancle-btn" @click="handleAccountCancle"
                        >取 消</el-button
                    >
                </div>
            </div>
        </el-dialog>
        <!-- 弹框 选择团队 -->
        <el-dialog
            title="选择团队"
            :visible.sync="dialogTeam"
            custom-class="member-wow-dialog"
            :before-close="handleBeforeClose"
            width="560px"
        >
            <div class="member-content">
                <div class="left-wraper">
                    <div class="search-content">
                        <el-input
                            class="search-tema"
                            placeholder="输入团队名称查询"
                            v-model.trim="memberForm.temaName"
                            @keyup.enter.native="queryAddMemberList('tema')"
                        >
                            <i
                                slot="suffix"
                                class="iconfont icon-search"
                                @click="queryAddMemberList('tema')"
                            ></i>
                        </el-input>
                    </div>

                    <div class="dialog-tema-content">
                        <el-checkbox-group
                            v-model="checkedTemas"
                            v-if="temaList.length > 0"
                        >
                            <el-checkbox
                                v-for="item in temaList"
                                :key="item.groupId"
                                :label="item.groupId"
                                @change="changeCheck(item, 'tema')"
                                ><i class="iconfont icon-user1 wow-user"></i
                                >{{ item.name }}</el-checkbox
                            >
                        </el-checkbox-group>
                        <div class="dialog-none-data" v-else>
                            <div>
                                <svg-icon icon-class="none1" />
                            </div>
                            <span>暂无数据</span>
                        </div>
                    </div>
                </div>
                <div class="right-wraper">
                    <div class="content_text">
                        <div class="choose_text">
                            已选择（{{ chooseData.length }}）
                        </div>
                        <div class="empty_text" @click="handleClear('tema')">
                            清空
                        </div>
                    </div>
                    <div class="choose-member">
                        <div
                            v-for="(item, index) in chooseData"
                            :key="index"
                            class="item-member"
                        >
                            <div>
                                <i class="iconfont icon-user1"></i>
                                <label class="member-text">{{
                                    item.name
                                }}</label>
                            </div>
                            <div>
                                <i
                                    class="el-icon-close"
                                    @click="
                                        hanldeDeleMember(item.groupId, index)
                                    "
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="chooseMember('tema')"
                    class="dialog-confirm-btn"
                    >确 定</el-button
                >
                <el-button @click="clearReturn" class="dialog-cancle"
                    >取 消</el-button
                >
            </span>
        </el-dialog>
        <!-- 选择科室 -->
        <el-dialog
            title="选择科室"
            :visible.sync="dialogDepart"
            custom-class="member-wow-dialog"
            :before-close="clearReturnTwo"
            width="560px"
        >
            <div class="member-content">
                <div class="left-wraper">
                    <div class="search-content">
                        <el-input
                            class="search-tema"
                            placeholder="输入科室名称查询"
                            v-model.trim="memberForm.departName"
                            @keyup.enter.native="queryAddMemberList('depart')"
                        >
                            <i
                                slot="suffix"
                                class="iconfont icon-search"
                                @click="queryAddMemberList('depart')"
                            ></i>
                        </el-input>
                    </div>

                    <div class="dialog-tema-content">
                        <el-checkbox-group
                            v-model="checkedDeparts"
                            v-if="dialogDepartList.length > 0"
                        >
                            <el-checkbox
                                v-for="item in dialogDepartList"
                                :key="item.groupId"
                                :label="item.groupId"
                                @change="changeCheck(item, 'depart')"
                                ><img
                                    class="depart-icon"
                                    src="../../../assets/imgs/folder.png"
                                    alt=""
                                />{{ item.name }}</el-checkbox
                            >
                        </el-checkbox-group>
                        <div class="dialog-none-data" v-else>
                            <div>
                                <svg-icon icon-class="none1" />
                            </div>
                            <span>暂无数据</span>
                        </div>
                    </div>
                </div>
                <div class="right-wraper">
                    <div class="content_text">
                        <div class="choose_text">
                            已选择（{{ chooseDataTwo.length }}）
                        </div>
                        <div class="empty_text" @click="handleClear('depart')">
                            清空
                        </div>
                    </div>
                    <div class="choose-member">
                        <div
                            v-for="(item, index) in chooseDataTwo"
                            :key="index"
                            class="item-member"
                        >
                            <div>
                                <img
                                    class="depart-icon"
                                    src="../../../assets/imgs/folder.png"
                                    alt=""
                                />
                                <label class="member-text">{{
                                    item.name
                                }}</label>
                            </div>
                            <div>
                                <i
                                    class="el-icon-close"
                                    @click="
                                        hanldeDeleMemberTwo(item.groupId, index)
                                    "
                                ></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button
                    type="primary"
                    @click="chooseMember('depart')"
                    class="dialog-confirm-btn"
                    >确 定</el-button
                >
                <el-button @click="clearReturnTwo" class="dialog-cancle"
                    >取 消</el-button
                >
            </span>
        </el-dialog>
    </div>
</template>
<script>
import { getToken } from "@/utils/auth";
import { mapGetters } from "vuex";
import { checkCard } from "@/utils/IDCard";
import { getIsCanBindPhone, postBindPhone, postMergeAccount } from "@/api/user";
import { postClinicGroupList } from "@/api/consultation";
import CropperPic from "@/components/cropperPic";
import { checkFileSize } from "@/utils/checkFiles";
export default {
    name: "userDetail",
    data() {
        return {
            proFileUploadForm: {},
            defaultProps: {
                emitPath: false,
                label: "groupName",
                value: "groupId"
            },
            flag: false,
            picUrl: "",
            loading: false,
            editShow: true,
            noEdit: true,
            sex: {
                0: "女",
                1: "男",
                2: "未知"
            },
            type: this.$route.query.type,
            doctorIuid: this.$route.query.doctorIuid,
            doctorMessage: {},
            breadList: [
                { label: "用户管理" },
                { label: "用户列表", path: "/user/userList" },
                { label: "编辑" }
            ],
            ruleForm: {
                identities: "doctor", // 医生
                iuid: "",
                hospitalId: "", // 医院id
                hospitalName: "", // 医院名称
                accountHead: "", // 头像
                accountName: "", // 用户姓名
                accountNumber: "", // 用户账号(工号)
                accountSex: "", // 性别
                doctorResume: "", // 简介
                doctorSpecial: "", // 擅长
                educationBackgroundCode: "", // 学历code
                educationBackgroundName: "", // 学历code
                educationCode: "", // 教育职称code
                educationName: "", // 教育职称
                titleName: "", // 职称
                titleCode: "", // 职称code
                idCard: "", // 身份证号
                idCardFront: "", // 身份证图片正面
                medicalLicenseFirst: "", // 医生执照first
                medicalLicenseSecond: "", // 医生执照second
                medicalRegisterFirst: "", // 医生注册first
                medicalRegisterSecond: "", // 医生注册second
                techFirst: "", // 专业技术资格证first
                otherCard: "",
                phone: "", // 手机号
                signatureUrl: "", // 签名
                departmentId: "", // 科室id
                departmentName: "", // 科室name
                groupIds: [], // 集团id
                roleIds: [] // 角色
            },
            haveDept: false, // 搜索
            isSearchDept: false,
            searchHospitalId: "", // 搜索医院ID 关联科室
            hospitalList: [], // 搜索的医院列表
            departList: [], // 科室列表
            gropList: [], // 集团列表
            roleList: [], // 角色列表
            // accountHeadFileList: [], // 头像资源
            idCardFrontFileList: [], // 身份证正资源
            idCardEndFileList: [], // 身份证反资源
            registFirstFileList: [], // 注册一
            registSecondFileList: [], // 注册二
            practiceFirstFileList: [], // 执业一
            practiceSecondFileList: [], // 执业二
            otherCardFileList: [],
            techFirstFileList: [],
            signFileList: [], // 电子签名资源
            dialogImageUrl: "", // 预览
            dialogVisible: false, // 预览显示
            // 剪切图片
            fileImg: {},
            cropperVisible: false,
            imageUrl: "",
            cropperPrewVisible: false,
            dialogAccountVisible: false,
            accountShow: false,
            imagePrewUrl: "", // 头像资源
            choosedglobalList: ["填写手机号", "确认手机号"],
            deleteUrl: require("../../../assets/imgs/delete.png"),
            errorShow: false,
            errorShow2: false,
            nextShow: false,
            accountLoading: false,
            phoneDisabled: false,
            accountForm: {
                phone: ""
            },
            strUrl: "/ms-hoc-video/v1/image/download?fileName=",
            dialogTeam: false, // 选择团队
            memberForm: {
                temaName: "",
                departName: ""
            },
            temaLoading: false,
            chooseData: [],
            checkedTemas: [],
            temaList: [],
            temaListShow: [],
            dialogDepart: false, // 选择科室
            departLoading: false,
            chooseDataTwo: [],
            checkedDeparts: [],
            dialogDepartList: [],
            departListShow: [],
            // 查看的标签
            departListShowSee: [],
            temaListShowSee: []
        };
    },
    updated() {
        if (this.$refs.vueCropper) {
            this.$refs.vueCropper.updateOption();
        }
    },
    computed: {
        ...mapGetters(["dictionary", "userInfo"]),
        headers() {
            return { Authorization: "Bearer " + getToken() + "" || undefined };
        }
    },
    components: {
        CropperPic
    },
    methods: {
        beforeUploadProfile1(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(
                file,
                this,
                2,
                "建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px"
            );
        },
        beforeUploadProfile2(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(
                file,
                this,
                2,
                "建议图片小于2M，图片格式为png、jpg、jpeg"
            );
        },
        beforeUploadProfile3(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(
                file,
                this,
                2,
                "建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1260px*890px"
            );
        },
        beforeUploadProfile4(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(
                file,
                this,
                2,
                "建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1260px*890px"
            );
        },
        beforeUploadProfile5(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(
                file,
                this,
                2,
                "建议图片小于2M，图片格式为png、jpg、jpeg"
            );
        },
        // 上传图片之前 限制
        beforeUploadProfile(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(file, this,1,'建议图片小于1M，图片格式为png、jpg、jpeg');
        },
        // 选择团队
        handleBeforeClose(done) {
            this.clearReturn();
            done();
        },
        handleBeforeCloseTwo(done) {
            this.clearReturnTwo();
            done();
        },
        // 清除信息团队
        clearReturn() {
            this.memberForm.temaName = "";
            this.chooseData = JSON.parse(JSON.stringify(this.temaListShow));
            this.checkedTemas = [];
            this.dialogTeam = false;
            this.temaListShow.forEach((item, index) => {
                this.checkedTemas.push(item.groupId);
            });
        },
        // 清除信息科室
        clearReturnTwo() {
            this.memberForm.departName = "";
            this.chooseDataTwo = JSON.parse(
                JSON.stringify(this.departListShow)
            );
            this.checkedDeparts = [];
            this.dialogDepart = false;
            this.departListShow.forEach((item, index) => {
                this.checkedDeparts.push(item.groupId);
            });
        },
        queryAddMemberList(type) {
            if (type === "tema") {
                this.getTemaList();
            } else if (type === "depart") {
                this.getDepartList();
            }
        },
        handleClear(type) {
            if (type === "tema") {
                this.chooseData = [];
                this.checkedTemas = [];
            } else {
                this.chooseDataTwo = [];
                this.checkedDeparts = [];
            }
        },
        chooseMember(type) {
            this.memberForm.temaName = "";
            this.memberForm.departName = "";
            if (type === "tema") {
                this.temaListShow = JSON.parse(JSON.stringify(this.chooseData));
                this.dialogTeam = false;
            } else {
                this.departListShow = JSON.parse(
                    JSON.stringify(this.chooseDataTwo)
                );
                this.dialogDepart = false;
            }
        },
        changeCheck(val, type) {
            if (type === "tema") {
                this.changeRightNow(val);
            } else {
                this.changeRightNowTwo(val);
            }
        },
        // 团队修改右侧
        changeRightNow(val) {
            let chooseId = this.checkedTemas;
            if (chooseId.indexOf(val.groupId) !== -1) {
                chooseId.forEach((choose, index) => {
                    if (val.groupId === choose) {
                        this.chooseData.push(val);
                    }
                });
            } else {
                this.chooseData.forEach((item, index) => {
                    if (val.groupId === item.groupId) {
                        this.chooseData.splice(index, 1);
                    }
                });
            }
        },
        // 科室修改右侧
        changeRightNowTwo(val) {
            let chooseId = this.checkedDeparts;
            if (chooseId.indexOf(val.groupId) !== -1) {
                chooseId.forEach((choose, index) => {
                    if (val.groupId === choose) {
                        this.chooseDataTwo.push(val);
                    }
                });
            } else {
                this.chooseDataTwo.forEach((item, index) => {
                    if (val.groupId === item.groupId) {
                        this.chooseDataTwo.splice(index, 1);
                    }
                });
            }
        },
        // 团队确定
        hanldeDeleMember(groupId, index) {
            let chooseId = this.checkedTemas;
            chooseId.forEach((item, key) => {
                if (item === groupId) {
                    this.checkedTemas.splice(key, 1);
                }
            });
            this.chooseData.splice(index, 1);
        },
        // 科室确定
        hanldeDeleMemberTwo(groupId, index) {
            let chooseId = this.checkedDeparts;
            chooseId.forEach((item, key) => {
                if (item === groupId) {
                    this.checkedDeparts.splice(key, 1);
                }
            });
            this.chooseDataTwo.splice(index, 1);
        },
        // 列表删除
        hanldeDeleShow(groupId, index, type) {
            if (type === "tema") {
                this.temaListShow.splice(index, 1);
                this.hanldeDeleMember(groupId, index);
            } else {
                this.departListShow.splice(index, 1);
                this.hanldeDeleMemberTwo(groupId, index);
            }
        },
        showTemaList(type) {
            if (type === "tema") {
                this.dialogTeam = true;
                this.getTemaList();
            } else {
                this.dialogDepart = true;
                this.getDepartList();
            }
        },
        // 获取团队列表
        async getTemaList() {
            this.temaLoading = true;
            let params = {
                state: "ONLINE",
                type: "EXPERTER",
                page: 1,
                size: 1000
            };
            if (this.memberForm.temaName) {
                params.name = this.memberForm.temaName;
            }
            const { results, state } = await postClinicGroupList(params);
            if (results && state === 200) {
                this.temaList = results;
            }
            this.temaLoading = false;
        },
        // 选择团队结束
        // 选择会诊 科室----------------
        // 获取科室列表
        async getDepartList() {
            this.departLoading = true;
            let params = {
                state: "ONLINE",
                type: "DEPT",
                page: 1,
                size: 1000
            };
            if (this.memberForm.departName) {
                params.name = this.memberForm.departName;
            }
            const { results, state } = await postClinicGroupList(params);
            if (results && state === 200) {
                this.dialogDepartList = results;
            }
            this.departLoading = false;
        },
        // 选择会诊 科室 结束
        handleAccountShow() {
            this.dialogAccountVisible = true;
            this.accountForm.phone = "";
            if (this.$refs["accountForm"]) {
                this.$refs["accountForm"].clearValidate();
            }
        },
        // 清除 406提示
        clearError() {
            if (this.errorShow2) {
                this.errorShow2 = false;
            }
        },
        // 关联手机号确定
        handleAccountConfirm() {
            this.$refs["accountForm"].validate(valid => {
                if (valid) {
                    this.handleIsCanBindPhone();
                } else {
                    return false;
                }
            });
        },
        async handleIsCanBindPhone() {
            const { state, results } = await getIsCanBindPhone(
                this.doctorMessage.iuid,
                this.accountForm.phone
            );
            if (state === 4061) {
                // 该手机号已注册，点击继续将合并账号
                this.errorShow = true;
                this.errorShow2 = false;
                this.nextShow = true;
                this.phoneDisabled = true;
            }
            if (state === 406) {
                // 手机号已绑定
                this.errorShow = false;
                this.errorShow2 = true;
                this.nextShow = false;
            }
            if (state === 200 && results) {
                this.handleBindPhone();
            }
        },
        // 返回state 200,results=true正常绑定手机号码
        async handleBindPhone() {
            this.accountLoading = true;
            const { results } = await postBindPhone(
                this.doctorMessage.iuid,
                this.accountForm.phone
            );
            if (results) {
                this.$message({
                    message: "成功关联手机号",
                    customClass: "hos-message--success",
                    iconClass: "el-icon-success",
                    duration: "1000"
                });
                this.dialogAccountVisible = false;
                // this.getData()
                this.initPhone();
            }
            this.accountLoading = false;
        },
        // 继续
        async handleNext() {
            this.accountLoading = true;
            const { results } = await postMergeAccount(
                this.doctorMessage.iuid,
                this.accountForm.phone
            );
            if (results) {
                this.$message({
                    message: "成功关联手机号",
                    customClass: "hos-message--success",
                    iconClass: "el-icon-success",
                    duration: "1000"
                });
                this.dialogAccountVisible = false;
                // this.getData()
                this.initPhone();
            }
            this.accountLoading = false;
        },
        // 关联好账号 进行 填入手机号
        initPhone() {
            this.ruleForm.phone = this.accountForm.phone;
            this.accountShow = false;
        },
        // 取消
        handleAccountCancle() {
            this.dialogAccountVisible = false;
            this.reSetAccount();
        },
        // 关闭弹框前调用方法
        handleClose(done) {
            this.reSetAccount();
            done();
        },
        reSetAccount() {
            this.errorShow = false;
            this.errorShow2 = false;
            this.nextShow = false;
            this.phoneDisabled = false;
            this.accountForm.phone = "";
        },
        // 处理下拉列表
        getSelect() {
            this.doctorJobList = this.dictionary.ZC;
            this.educationList = this.dictionary.XL;
            this.facultyList = this.dictionary.JZ;
            this.getRole();
            this.getGroup("");
        },
        async getRole() {
            const { results } = await this.$services.hospital.getRoleList();
            this.roleList = results;
        },
        async getData() {
            this.loading = true;
            const { results } = await this.$services.hospital.getDoctorDetail(
                this.doctorIuid
            );
            this.doctorMessage = JSON.parse(JSON.stringify(results));
            this.handleSeeData(this.doctorMessage);
            this.handleData(results);
        },
        // 处理查看的信息
        handleSeeData(data) {
            if (data.hospitalId) {
                this.getTreeDepart(data.hospitalId, data, "first");
            }
            // 集团
            if (data.groupVOs) {
                let group = data.groupVOs;
                let arr = [];
                for (let j in group) {
                    arr.push(group[j].groupName);
                }
                data.groups = arr.join(" | ");
            }
            // 角色
            if (data.roles) {
                let roles = data.roles;
                let arr = [];
                for (let j in roles) {
                    arr.push(roles[j].roleName);
                }
                data.roles = arr.join(" | ");
            }
            // 打标签 团队和科室
            if (data.clinicInfo) {
                let depart = JSON.parse(
                    JSON.stringify(data.clinicInfo.deptGroup)
                );
                let tema = JSON.parse(
                    JSON.stringify(data.clinicInfo.experterGroup)
                );
                this.temaListShowSee = tema || [];
                this.departListShowSee = depart || [];
            }
        },
        // 获取 树状 科室
        async getTreeDepart(hosId, data, type) {
            let params = {
                hospitalId: hosId
            };
            const { results } = await this.$services.hospital.getTreeDeptList(
                params
            );
            this.departList = results;
            // 科室名字
            if (type === "first") {
                if (data.departmentVO) {
                    data.departName = data.departmentVO.groupName;
                    if (data.departmentVO.parentId) {
                        this.departList.map(item => {
                            if (item.groupId === data.departmentVO.parentId) {
                                data.departName =
                                    item.groupName + " / " + data.departName;
                            }
                        });
                    }
                }
            }
        },
        isHaveHospital(value) {
            if (!this.searchHospitalId) {
                this.$message({
                    message: "请先输入医院",
                    customClass: "hos-message--warning",
                    iconClass: "el-icon-warning",
                    duration: "1000"
                });
            }
        },
        // 医院搜索
        async getHospital(value, type) {
            this.isSearchDept = true;
            const params = {
                searchName: value
            };
            const {
                results
            } = await this.$services.hospital.getAllHospitalList(params);
            this.isSearchDept = false;
            this.hospitalList = results;
            if (type !== "first") {
                this.departList = [];
            }
        },
        // 搜索集团
        async getGroup(value) {
            this.isSearchDept = true;
            const params = {
                searchName: value
            };
            const {
                results
            } = await this.$services.hospital.getAllHospitalGroupList(params);
            this.isSearchDept = false;
            this.gropList = results;
        },
        // 处理编辑信息
        handleData(data) {
            let list = this.ruleForm;
            if (data.idCardFront) {
                this.idCardFrontFileList = [
                    { name: "", url: this.strUrl + data.idCardFront }
                ];
            }
            if (data.accountHead) {
                this.imageUrl = this.strUrl + data.accountHead;
            }
            if (data.medicalLicenseFirst) {
                this.practiceFirstFileList = [
                    { name: "", url: this.strUrl + data.medicalLicenseFirst }
                ];
            }
            if (data.medicalLicenseSecond) {
                this.practiceSecondFileList = [
                    { name: "", url: this.strUrl + data.medicalLicenseSecond }
                ];
            }
            if (data.medicalRegisterFirst) {
                this.registFirstFileList = [
                    { name: "", url: this.strUrl + data.medicalRegisterFirst }
                ];
            }
            if (data.medicalRegisterSecond) {
                this.registSecondFileList = [
                    { name: "", url: this.strUrl + data.medicalRegisterSecond }
                ];
            }
            if (data.signatureUrl) {
                this.signFileList = [
                    { name: "", url: this.strUrl + data.signatureUrl }
                ];
            }
            if (data.otherCard) {
                this.otherCardFileList = [
                    { name: "", url: this.strUrl + data.otherCard }
                ];
            }
            if (data.techFirst) {
                this.techFirstFileList = [
                    { name: "", url: this.strUrl + data.techFirst }
                ];
            }
            if (data.hospitalName) {
                this.getHospital(data.hospitalName, "first");
                this.searchHospitalId = data.hospitalId;
            }
            // 集团
            if (data.groupVOs) {
                let group = data.groupVOs;
                list.groupIds = [];
                for (let j in group) {
                    list.groupIds.push(group[j].groupId);
                }
            }
            // 科室
            if (data.departmentVO) {
                list.departmentName = data.departmentVO.groupName;
                list.departmentId = data.departmentVO.groupId;
            }
            // 角色
            if (data.roles) {
                let roles = data.roles;
                list.roleIds = [];
                for (let j in roles) {
                    list.roleIds.push(roles[j].roleId);
                }
            }
            // 性别
            data.accountSex = "" + data.accountSex;
            for (let key in list) {
                for (let dKey in data) {
                    if (key === dKey) {
                        list[key] = data[dKey];
                    }
                }
            }
            // 关联账号
            if (!this.ruleForm.phone) {
                this.accountShow = true;
            } else {
                this.accountShow = false;
            }
            // 打标签 团队和科室
            if (data.clinicInfo) {
                let depart = data.clinicInfo.deptGroup;
                let tema = data.clinicInfo.experterGroup;
                this.temaListShow = tema || [];
                this.departListShow = depart || [];
                this.chooseDataTwo = JSON.parse(
                    JSON.stringify(data.clinicInfo.deptGroup)
                );
                this.chooseData = JSON.parse(
                    JSON.stringify(data.clinicInfo.experterGroup)
                );
                depart.forEach((item, index) => {
                    this.checkedDeparts.push(item.groupId);
                });
                tema.forEach((item, index) => {
                    this.checkedTemas.push(item.groupId);
                });
            }
            this.loading = false;
        },
        isCancle() {
            if (this.type === "edit") {
                this.$router.push("/user/userList");
            } else if (this.type === "show") {
                this.editShow = false;
                // this.getData()
            }
        },
        // ----------编辑--------------//
        // ------------code name----------
        // 添加医院name
        handleHosChange(val) {
            this.searchHospitalId = val;
            this.ruleForm.departmentId = "";
            this.departList = [];
            let obj = {};
            obj = this.hospitalList.find(item => {
                return item.hospitalId === val;
            });
            if (val) {
                this.ruleForm.hospitalName = obj.hospitalName;
                this.getTreeDepart(val);
            } else {
                this.ruleForm.hospitalName = "";
            }
        },
        // 教育职称name
        handleEduChange(val) {
            let obj = {};
            obj = this.facultyList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.educationName = obj.dictDataValue;
            } else {
                this.ruleForm.educationName = "";
            }
        },
        // 学历name
        handleEducationChange(val) {
            let obj = {};
            obj = this.educationList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.educationBackgroundName = obj.dictDataValue;
            } else {
                this.ruleForm.educationBackgroundName = "";
            }
        },
        // 职称name
        handleTitleChange(val) {
            let obj = {};
            obj = this.doctorJobList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.titleName = obj.dictDataValue;
            } else {
                this.ruleForm.titleName = "";
            }
        },
        // ------------code name------------------
        // 验证身份证
        checkId(rule, value, callback) {
            if (value) {
                if (checkCard(value) === false) {
                    callback(new Error("请输入正确的身份证号"));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        },
        // 身份证正面图片上传
        handleCardFrontSuccess(res, file) {
            let data = res.results;
            this.ruleForm.idCardFront = data[0].fileId;
            this.$refs["ruleForm"].validateField("idCardFront");
        },
        // 工作证或参会胸牌
        handleOtherCardSuccess(res, file) {
            let data = res.results;
            this.ruleForm.otherCard = data[0].fileId;
        },
        // 注册第一
        handleRegisterFirstSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalRegisterFirst = data[0].fileId;
        },
        // 注册第二
        handleRegisterSecondSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalRegisterSecond = data[0].fileId;
        },
        // 执照第一
        handleLicenseFirstSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalLicenseFirst = data[0].fileId;
        },
        // 执照第二
        handleLicenseSecondSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalLicenseSecond = data[0].fileId;
        },
        // 专业技术资格证一
        handleTechFirstSuccess(res, file) {
            let data = res.results;
            this.ruleForm.techFirst = data[0].fileId;
        },
        // 签名成功
        handleSignSuccess(res, file) {
            let data = res.results;
            this.ruleForm.signatureUrl = data[0].fileId;
        },
        // 身份证正面图片删除
        handleCardFrontRemove(file, fileList) {
            this.ruleForm.idCardFront = "";
        },
        // 工作证或参会胸牌删除
        handleOtherCardRemove(file, fileList) {
            this.ruleForm.otherCard = "";
        },
        // 注册第一删除
        handleRegisterFirstRemove(file, fileList) {
            this.ruleForm.medicalRegisterFirst = "";
        },
        // 注册第二删除
        handleRegisterSecondRemove(file, fileList) {
            this.ruleForm.medicalRegisterSecond = "";
        },
        // 执照第一删除
        handleLicenseFirstRemove(file, fileList) {
            this.ruleForm.medicalLicenseFirst = "";
        },
        // 执照第二删除
        handleLicenseSecondRemove(file, fileList) {
            this.ruleForm.medicalLicenseSecond = "";
        },
        // 专业技术资格证一删除
        handleTechFirstRemove(file, fileList) {
            this.ruleForm.techFirst = "";
        },
        // 签名删除 signatureUrl
        handleSignRemove(file, fileList) {
            this.ruleForm.signatureUrl = "";
        },
        // 编辑医生
        handleEdit() {
            let flag1 =
                this.ruleForm.medicalRegisterFirst &&
                this.ruleForm.medicalRegisterSecond;

            let flag2 =
                this.ruleForm.medicalLicenseFirst &&
                this.ruleForm.medicalLicenseSecond;

            let flag3 = this.ruleForm.techFirst;

            let flag4 = this.ruleForm.otherCard;

            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    if (flag1 || flag2 || flag3 || flag4) {
                        this.handlePutDoctor();
                    } else {
                        this.$message({
                            message:
                                "请上传医师注册执业证、执业医师资格证、专业技术资格证、工作证或参会胸牌（至少一项必填）",
                            customClass: "hos-message--warning",
                            iconClass: "el-icon-warning",
                            duration: "3000"
                        });
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 请求接口编辑医生
        async handlePutDoctor() {
            this.loading = true;
            this.flag = true;
            let param = this.ruleForm;
            // 如果打了标签
            param.clinicExperterGroupIds = this.checkedTemas;
            param.clinicDeptGroupIds = this.checkedDeparts;
            // 打标签参数结束
            delete param["departmentName"];
            const { results } = await this.$services.hospital.editDoctor(param);
            this.loading = false;
            this.flag = false;
            if (results) {
                this.$message({
                    message: "编辑医生成功",
                    customClass: "hos-message--success",
                    iconClass: "el-icon-success",
                    duration: "1000"
                });
                if (this.type === "edit") {
                    this.$router.push("/user/userList");
                } else if (this.type === "show") {
                    this.editShow = false;
                    this.getData();
                }
            }
        },
        handlePictureCardPreview(file) {
            let reg = new RegExp("ZIP");
            file.url = file.url.replace(reg, "");
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        toPreview(file) {
            let reg = new RegExp("ZIP");
            file = file.replace(reg, "");
            this.dialogImageUrl = this.strUrl + file;
            this.dialogVisible = true;
        },
        clearUrl() {
            this.dialogImageUrl = "";
            this.dialogVisible = false;
        },
        // 剪切提交图片-------
        changeUpload(file, fileList) {
            if (file && file.size / 1024 / 1024 > 1) {
                return this.$message.warning(
                    "建议图片小于1M，图片格式为png、jpg、jpeg，图片尺寸建议500px*500px"
                );
            }
            this.fileImg = file;
            this.cropperVisible = true;
        },
        // 提交图片
        async uploadFile(data) {
            // console.log(data, '99999')
            let hospitalId = this.userInfo.hospitalId;
            let iuid = this.userInfo.iuid;
            let formData = new FormData();
            formData.append("file", data);
            const { results, state } = await this.$services.hospital.imgUpload(
                formData,
                hospitalId,
                iuid
            );
            if (state === 200 && results) {
                this.cropperVisible = false;
                this.imageUrl = this.strUrl + results[0].originPictureId;
                this.ruleForm.accountHead = results[0].originPictureId;
            } else {
                this.$refs.vueCropper.cropperLoadding = false;
                this.$message({
                    message: "上传头像失败，请稍后再试",
                    customClass: "hos-message--error",
                    iconClass: "el-icon-error",
                    duration: "1000"
                });
            }
        },
        avartIn(file) {
            let reg = new RegExp("ZIP");
            file = file.replace(reg, "");
            this.imagePrewUrl = file;
            this.cropperPrewVisible = true;
        },
        avartDele() {
            this.imageUrl = "";
            this.ruleForm.accountHead = "";
        },
        handleAvartClose() {
            this.cropperPrewVisible = false;
        }
    },
    created() {
        this.picUrl = `/ms-hoc-material/v3/file/uploadSingleFile?folder=hoc`;
        // this.picUrl = `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=DOCTOR_INFO_IMAGE`
        if (this.type === "edit") {
            this.editShow = true;
            this.breadList[2].label = "编辑";
        } else if (this.type === "show") {
            this.editShow = false;
            this.breadList[2].label = "医生信息";
        }
        this.getSelect();
        this.getData();
    }
};
</script>

<style lang="scss" scoped>
.user-detail-wrap-out {
    .doctorDetail-wrap {
        background: #ffffff;
        margin: 20px;
        padding: 20px 20px 0px 20px;
        overflow: hidden;
        box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
        .hospital-title {
            padding-bottom: 8px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px solid #cccccc;
            display: flex;
            justify-content: space-between;
            i {
                color: $color-primary;
            }
            span {
                margin-left: 8px;
            }
            .title-edit {
                display: flex;
                align-items: center;
                cursor: pointer;
                i {
                    color: $icon-edit;
                }
                span {
                    margin-left: 6px;
                    color: $icon-text;
                    font-size: 12px;
                }
            }
        }
        .info-title {
            margin-bottom: 20px;
            border-left: 4px solid $color-primary;
            padding-left: 8px;
            height: 16px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 16px;
            color: #333333;
            text-align: left;
        }
        .doctorDetail-wrap-see {
            .doctor-base-info {
                // padding-bottom: 20px;
                border-bottom: 1px solid #cccccc;
                padding-top: 20px;
                .base-info-wrap {
                    margin-bottom: 20px;
                    display: flex;
                    // align-items: center;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    line-height: 14px;
                    color: #333333;
                    .info-label {
                        margin-right: 20px;
                        width: 78px;
                        text-align: right;
                        color: #666666;
                    }
                    .info-label-min {
                        min-width: 78px;
                    }
                    .info-label-te {
                        width: 78px;
                    }
                    .info-label-big {
                        width: 88px;
                    }
                    .info-message-detail {
                        width: 60%;
                        min-width: 700px;
                        line-height: 22px;
                        // max-height: 88px;
                        word-break: break-all;
                        word-wrap: break-word;
                    }
                }
                .avtar-cover {
                    margin-bottom: 20px;
                    padding-left: 12px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #333333;
                    letter-spacing: 0;
                    text-align: left;
                    line-height: 14px;
                    img {
                        display: block;
                        width: 120px;
                        height: 120px;
                        cursor: pointer;
                    }
                    .info-message {
                        height: 100px;
                        line-height: 100px;
                    }
                    .info-avart-none {
                        width: 120px;
                        height: 120px;
                        background: #dcdcdc;
                        position: relative;
                        i {
                            color: #ffffff;
                            font-size: 80px;
                            position: absolute;
                            left: 20px;
                            top: 52px;
                        }
                    }
                }
            }
            .doctor-cert-info {
                padding-top: 20px;
                padding-bottom: 20px;
                border-bottom: 1px solid #cccccc;
                .info-cert-wrap {
                    padding-left: 13px;
                    .info-cert-item {
                        font-family: PingFangSC-Regular;
                        font-size: 14px;
                        line-height: 14px;
                        color: #333333;
                        margin-bottom: 20px;
                        display: flex;
                        .papers {
                            display: block;
                            width: 200px;
                            height: 134px;
                            border-radius: 3px;
                            cursor: pointer;
                        }
                        .paper-sign {
                            display: block;
                            width: 70px;
                            height: 70px;
                            border-radius: 0px;
                            cursor: pointer;
                        }
                        .info-label {
                            margin-right: 20px;
                            width: 120px;
                            text-align: right;
                            color: #666666;
                        }
                        .info-pic {
                            display: flex;
                            .pic-cover {
                                margin-right: 20px;
                            }
                        }
                    }
                    .info-cert-item:last-child {
                        margin-bottom: 0px;
                    }
                }
            }
        }
        // 编辑
        .rule-from {
            .doctor-base-info {
                border-bottom: 1px solid #cccccc;
                padding-top: 20px;
                .avart-wrap {
                    position: relative;
                    .avatar-uploader {
                        .avatar-show {
                            width: 118px;
                            height: 118px;
                        }
                        .avatar-img {
                            width: 120px;
                            height: 120px;
                            display: flex;
                            align-items: center;
                            flex-direction: column;
                            position: relative;
                            i {
                                width: 24px;
                                height: 21px;
                                font-size: 20px;
                                color: #ffffff;
                                position: absolute;
                                top: -26px;
                            }
                            div {
                                color: #ffffff;
                                font-size: 14px;
                            }
                            .uploader-title {
                                width: 56px;
                                height: 14px;
                                color: #ffffff;
                                font-size: 14px;
                            }
                        }
                    }
                    .cover-custom {
                        width: 120px;
                        height: 120px;
                        position: absolute;
                        top: 0;
                        left: 0;
                        z-index: 888;
                        .cover-wrap {
                            width: 120px;
                            height: 120px;
                            background: rgba(0, 0, 0, 0.4);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            opacity: 0;
                            i {
                                color: #ffffff;
                                font-size: 20px;
                                cursor: pointer;
                            }
                            i:first-child {
                                margin-right: 10px;
                            }
                        }
                    }
                    .cover-custom:hover .cover-wrap {
                        animation: myfirst 0.5s;
                        -moz-animation: myfirst 0.5s; /* Firefox */
                        -webkit-animation: myfirst 0.5s; /* Safari 和 Chrome */
                        -o-animation: myfirst 1s; /* Opera */
                        animation-fill-mode: forwards; /*ie9 及以下不支持 */
                        -moz-animation-fill-mode: forwards;
                        -webkit-animation-fill-mode: forwards;
                        -o-animation-fill-mode: forwards;
                    }
                    // ceshi
                    @keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    @-moz-keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    @-webkit-keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }

                    @-o-keyframes myfirst {
                        from {
                            opacity: 0;
                        }
                        to {
                            opacity: 1;
                        }
                    }
                }
                .accout-link {
                    margin-left: 10px;
                }
            }
            .cert-info {
                // border-bottom: none;
                .papers-uploader {
                    .icon {
                        font-size: 140px;
                    }
                }
                .heart-warning {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #999999;
                    letter-spacing: 0;
                    line-height: 16px;
                }
                .ele-sign {
                    .sign-qian {
                        width: 70px;
                        height: 70px;
                        position: relative;
                        .icon {
                            position: absolute;
                            left: 0;
                            top: 0;
                        }
                    }
                }
            }
            .avatar-uploader {
                .avatar-img {
                    width: 120px;
                    height: 120px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    position: relative;

                    i {
                        width: 24px;
                        height: 21px;
                        font-size: 20px;
                        color: #ffffff;
                        position: absolute;
                        top: -26px;
                    }
                    div {
                        color: #ffffff;
                        font-size: 14px;
                    }
                    .uploader-title {
                        width: 56px;
                        height: 14px;
                        color: #ffffff;
                        font-size: 14px;
                    }
                }
            }
            .form-tips-text {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                margin: 20px 0;
            }
        }
        // 标签信息开始
        .set-label {
            border-bottom: none !important;
            .label-wrap {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
                line-height: 14px;
                padding-left: 14px;
                .label-team {
                    margin-bottom: 20px;
                    display: flex;
                    .label-team-left {
                        margin-right: 20px;
                        min-width: 56px;
                        line-height: 18px;
                    }
                    .label-team-right {
                        .label-team-select {
                            // margin-bottom: 10px;
                            color: $color-primary;
                            display: flex;
                            align-items: center;
                            cursor: pointer;
                            i {
                                font-size: 18px;
                                margin-right: 8px;
                            }
                        }
                        .label-team-content {
                            display: flex;
                            flex-wrap: wrap;
                            .team-content-item {
                                margin-top: 10px;
                                margin-right: 10px;
                                display: flex;
                                align-items: center;
                                height: 24px;
                                padding: 0 10px;
                                border: 1px solid #f2f2f2;
                                border-radius: 3px;
                                color: #333333;
                                .wow-user {
                                    margin-right: 10px;
                                    font-size: 10px;
                                    color: $color-primary;
                                }
                                .wow-close {
                                    margin-left: 10px;
                                    font-size: 6px;
                                    color: #999999;
                                    cursor: pointer;
                                }
                                .wow-folder {
                                    margin-right: 10px;
                                    width: 11px;
                                    height: 11px;
                                    display: inline-block;
                                    background: url("../../../assets/imgs/folder.png")
                                        no-repeat;
                                    background-size: cover;
                                }
                            }
                        }
                    }
                }
            }
        }
        // 标签信息结束
        // 查看标签信息
        .see-set-label {
            padding-bottom: 10px;
            .info-title {
                margin-bottom: 10px;
            }
            .label-wrap {
                .label-team {
                    .label-team-left {
                        margin-top: 10px;
                        min-width: 60px;
                    }
                }
            }
        }
        // 查看标签结束
    }
    .add-btn-bottom {
        width: 100%;
        height: 60px;
        background: #f9f9f9;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    // 团队
    .dialog-tema-content {
        padding-right: 10px;
        height: 400px;
        overflow: auto;
        .dialog-tema-item {
            margin-bottom: 14px;
            display: flex;
            justify-content: space-between;
            .dialog-tema-item-left {
                span {
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #333333;
                    letter-spacing: 0;
                    line-height: 12px;
                }
            }
            .wow-user {
                margin-right: 10px;
                font-size: 10px;
                color: $color-primary;
            }
        }
    }
    // 无数据
    .dialog-none-data {
        height: 400px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .icon {
            font-size: 80px;
        }
        span {
            line-height: 14px;
            font-size: 12px;
        }
    }
}
</style>

<style lang="scss">
.user-detail-wrap-out {
    .el-textarea__inner {
        padding: 5px 15px 32px 15px !important;
    }
}
.account-dialog {
    .el-dialog__body {
        .account-wrap {
            padding-bottom: 20px;
            .el-form-item__label {
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 0;
            }
            .el-form-item__content {
                .phone-input {
                    width: 260px;
                    height: 32px;
                    .el-input__inner {
                        height: 32px;
                        border-radius: 3px;
                        padding: 0 10px;
                    }
                }

                .error-mes {
                    margin-left: 20px;
                    font-family: PingFangSC-Regular;
                    font-size: 12px;
                    color: #f36969;
                    position: relative;
                    font-family: "iconfont" !important;
                    font-style: normal;
                    -webkit-font-smoothing: antialiased;
                    &:before {
                        font-size: 16px;
                        position: absolute;
                        left: -22px;
                        top: 0;
                        content: "\E650";
                    }
                }
            }
        }

        .dialog-footer {
            height: 32px;
            display: flex;
            align-items: center;
            margin-left: 80px;
            .confirm-btn {
                background: #06aea6;
                border-radius: 3px;
                padding: 0;
                width: 100px;
                height: 32px;
                border: none;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #ffffff;
                letter-spacing: 4px;
            }
            .cancle-btn {
                background: #f5f5f5;
                border: 1px solid #cccccc;
                border-radius: 3px;
                padding: 0;
                width: 100px;
                height: 32px;
                font-family: PingFangSC-Regular;
                font-size: 14px;
                color: #666666;
                letter-spacing: 4px;
                margin-left: 16px;
            }
        }
    }
}
// 标签弹窗布局
.el-dialog__wrapper {
    .member-wow-dialog {
        .el-dialog__body {
            padding: 0;
            .member-content {
                height: 453px;
                display: flex;
                .left-wraper {
                    padding-left: 10px;
                    width: 340px;
                    border-right: 1px solid #dcdcdc;
                    .search-content {
                        margin: 10px 0;
                        width: 319px;
                        padding-right: 10px;
                        .search-tema {
                            width: 319px;
                            vertical-align: middle;
                            .el-input__inner {
                                border-radius: 3px;
                                border-color: #dcdcdc;
                                padding: 8px 32px 8px 10px;
                                height: 32px;
                                font-size: 12px;
                            }
                            .el-input__inner::-webkit-input-placeholder {
                                font-size: 12px;
                            }

                            .el-input__suffix {
                                background: $color-primary;
                                color: #fff;
                                right: 0;
                                cursor: pointer;
                                border-radius: 0 3px 3px 0;

                                i {
                                    display: inline-block;
                                    width: 36px;
                                    font-size: 14px;
                                    line-height: 32px;
                                    border-radius: 3px;
                                }
                            }
                        }
                    }
                    .table-content {
                        margin-top: 10px;
                    }
                }
                .right-wraper {
                    width: 220px;
                    padding: 20px;
                    padding-right: 0px;
                    overflow: hidden;
                    .content_text {
                        padding-right: 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .choose_text {
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #999999;
                            letter-spacing: 0;
                        }
                        .empty_text {
                            cursor: pointer;
                            font-family: PingFangSC-Regular;
                            font-size: 12px;
                            color: #198eeb;
                            letter-spacing: 0;
                        }
                    }
                    .choose-member {
                        height: 396px;
                        padding-right: 20px;
                        overflow: auto;
                        margin-top: 10px;
                        padding-top: 10px;
                        .item-member {
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            margin-bottom: 10px;
                            .icon-user1 {
                                font-size: 14px;
                                color: #06aea6;
                            }
                            .el-icon-close {
                                color: #999;
                                font-size: 14px;
                                cursor: pointer;
                            }
                            .member-text {
                                margin-left: 10px;
                                font-family: PingFangSC-Regular;
                                font-size: 12px;
                                color: #333333;
                                letter-spacing: 0;
                            }
                        }
                    }
                }
            }
        }
        .el-dialog__footer {
            background: #f9f9f9;
            height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            .dialog-footer {
                .dialog-confirm-btn {
                    width: 100px;
                    height: 32px;
                    padding: 0;
                }
                .dialog-cancle {
                    background: #f5f5f5;
                    border: 1px solid #cccccc;
                    border-radius: 3px;
                    padding: 0;
                    width: 100px;
                    height: 32px;
                    font-family: PingFangSC-Regular;
                    font-size: 14px;
                    color: #666666;
                    margin-left: 16px;
                }
            }
        }
    }
}
.dialog-tema-content {
    // checkbox
    .el-checkbox-group {
        .el-checkbox {
            display: flex;
            justify-content: space-between;
            flex-flow: row-reverse;
            margin-bottom: 14px;
            margin-right: 0px;
            .el-checkbox__label {
                padding-left: 0px;
                font-size: 12px;
                float: left;
                color: #333333;
                i {
                    margin-right: 10px;
                    font-size: 12px;
                    color: $color-primary;
                }
                .depart-icon {
                    margin-right: 10px;
                }
            }
        }
    }
}
.depart-icon {
    display: inline-block;
    width: 14px;
    height: 12px;
}
</style>
